import * as countries from "i18n-iso-countries";
// @ts-expect-error Missing type definitions for locale file
import enLocale from "i18n-iso-countries/langs/en.json";

countries.registerLocale(enLocale);

export const COUNTRY_OPTIONS = Object.entries(countries.getNames("en"))
  .map(([value, label]) => ({ value, label }))
  .sort((first, second) => first.label.localeCompare(second.label));
